
import { useEffect, useState, memo } from 'react';
import Grid from '@material-ui/core/Grid';
import { FormikProvider, Field } from 'formik';
import { isEqual } from 'lodash';

const SanegrPrimerRowErrors = memo((props) => {
    const data = props.data;
    const primerColors = props.primerColors;
    const primerKey = props.primerKey;
    const formik = props.formik;
    const showAllErrors = props.showAllErrors;
    const submitShowError = props.submitShowError;
    const index = props.index;
  
  return (
    <FormikProvider value={formik}>
        <Grid item xs={12} style={{marginBottom: 0}}>
        <Field name={`primerMapToList.${index}`}>
        {({ field, form: { touched, errors }, meta }) => (
        meta.error != undefined ? (
            <ul style={{listStyleType: 'disc',
            verticalAlign: 'middle',
            color: '#d8000c',
            margin: 0,
            backgroundColor: '#ffd2d2'}}>
            {meta.error.count ? <>● {meta.error.count}<br></br></> : <></>}
            {(data.touched[0] || submitShowError) && showAllErrors ? (
            <li>
            {meta.error.primerName ? <>● {meta.error.primerName}</> : <></>}
            </li> ) : (<>
            </>)}
            {(data.touched[1] || submitShowError) && showAllErrors ? (
            <li>
            {meta.error.vol ? <>● {meta.error.vol}</> : <></>}
            </li> ) : (<>
            </>)}
            </ul>) : (<>
            </>)
        )}
        </Field>
        </Grid>
        </FormikProvider>
    );
},
(prevProps, nextProps) => {
    let oldIndex = prevProps.index;
    let newIndex = nextProps.index;
    if (nextProps.formik.errors?.primerMapToList?.[oldIndex] !== prevProps.formik.errors?.primerMapToList?.[newIndex]) {
        return false; // re-render
      }
    return prevProps.id === nextProps.id && isEqual(prevProps.data, nextProps.data) && prevProps.data.count == nextProps.data.count
    && prevProps.showAllErrors == nextProps.showAllErrors && prevProps.reactCount == nextProps.reactCount;
});

export default SanegrPrimerRowErrors;